// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { tag16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-tag': IconTag;
    }
}

/**
 * The icon component for the 'tag' icon
 */
export class IconTag extends Icon {
    public constructor() {
        super(tag16X16);
    }
}

registerIcon('icon-tag', IconTag);
export const iconTagTag = 'nimble-icon-tag';
